import React, { Fragment, useContext } from "react";

import { Typography, Grid, Card, Stack, Button } from "@mui/material";
import { inputStyles } from "../../react_utils/StyledElements";

import CharsInput from "../../react_utils/fields/CharsInput";
import { MessagingContext } from "../MessagingContext";
import { AuthContext } from "../../shared/contexts/AuthContext";
import usePasswordChange from "../../shared/hooks/settings/usePasswordChange";

const styles = {
  ...inputStyles,
};

export default function Settings() {
  const { apiClient } = useContext(AuthContext);
  const { showMessage } = useContext(MessagingContext);

  const { onSubmit, password1, password2 } = usePasswordChange(
    apiClient,
    showMessage,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Fragment>
      <Grid container justify="center">
        <Grid
          xs={12}
          md={6}
          lg={4}
          xl={3}
          item
          justifyContent="center"
          alignItems="center"
          sx={{ marginY: "20px" }}
        >
          <Card
            sx={{
              padding: "10px",
              backgroundColor: "tertiary.main",
            }}
          >
            <Typography color="secondary" variant="h6">
              Passwort ändern
            </Typography>
            <form style={styles.form} noValidate onSubmit={handleSubmit}>
              <Stack direction={"column"} spacing={3}>
                <CharsInput
                  label="Passwort eingeben"
                  placeholder="Passwort"
                  type="password"
                  onChange={(v) => password1.setValue(v)}
                />
                <CharsInput
                  label="Passwort erneut eingeben"
                  placeholder="Passwort"
                  type="password"
                  onChange={(v) => password2.setValue(v)}
                />
                <Button
                  type="submit"
                  variant="outlined"
                  style={{ color: "#efefef", borderColor: "#efefef" }}
                  sx={styles.submit}
                >
                  Passwort ändern
                </Button>
              </Stack>
            </form>
          </Card>
        </Grid>
      </Grid>
    </Fragment>
  );
}

Settings.propTypes = {};
